<template>
  <FKBreadCrumb :page="$t('page.zones')" />
  <ZonesList /> 
</template>

<script lang="ts">
import { defineComponent } from "vue";

import FKBreadCrumb from "@/components/Widgets/BreadCrumb/FKBreadCrumb.vue";
import ZonesList from "@/components/FK/Zones/ZonesList.vue";

export default defineComponent({
  name: "ZonesPage",
  components: {
    FKBreadCrumb,
    ZonesList,
  },
});
</script>